import { render } from "./BaseQuestionPage.vue?vue&type=template&id=7eef53b4&scoped=true"
import script from "./BaseQuestionPage.vue?vue&type=script&lang=js"
export * from "./BaseQuestionPage.vue?vue&type=script&lang=js"

import "./BaseQuestionPage.vue?vue&type=style&index=0&id=7eef53b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eef53b4"]])

export default __exports__